export default __webpack_public_path__ + "static/media/bg@2x.fb732147.jpg";